import { createFileRoute, redirect } from "@tanstack/react-router";

// Portal's `_protected.$school.account-settings._index` — redirect to the default (account-info) tab.
export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/account-settings/",
)({
  loader: ({ params }) => {
    throw redirect({
      to: "/$locale/{-$schoolyear}/$school/account-settings/account-info",
      params: { locale: params.locale, schoolyear: params.schoolyear, school: params.school },
    });
  },
});
